export const data = [
    {
        id: 1,
        name: "BJÖRKSTA",
        desc: "Obraz z ramą, 200x300 cm",
        price: "999,-",
        img: "https://placekitten.com/g/3000/2000"
    },
    {
        id: 2,
        name: "BJÖRKSTA",
        desc: "Obraz z ramą, 200x200 cm",
        price: "999,-",
        img: "https://placekitten.com/g/2000/2000"
    },
    {
        id: 3,
        name: "BJÖRKSTA",
        desc: "Obraz z ramą, 200x400 cm",
        price: "999,-",
        img: "https://placekitten.com/g/3500/2000"
    },
    {
        id: 4,
        name: "BJÖRKSTA",
        desc: "Obraz z ramą, 400x300 cm",
        price: "999,-",
        img: "https://placekitten.com/g/3500/2500"
    },
    {
        id: 5,
        name: "BJÖRKSTA",
        desc: "Obraz z ramą, 300x300 cm",
        price: "999,-",
        img: "https://placekitten.com/g/3000/3000"
    },
    {
        id: 6,
        name: "BJÖRKSTA",
        desc: "Obraz z ramą, 200x300 cm",
        price: "999,-",
        img: "https://placekitten.com/g/3000/2000"
    },
    {
        id: 7,
        name: "BJÖRKSTA",
        desc: "Obraz z ramą, 200x200 cm",
        price: "999,-",
        img: "https://placekitten.com/g/2000/2000"
    },
    {
        id: 8,
        name: "BJÖRKSTA",
        desc: "Obraz z ramą, 200x400 cm",
        price: "999,-",
        img: "https://placekitten.com/g/3500/2000"
    },
    {
        id: 9,
        name: "BJÖRKSTA",
        desc: "Obraz z ramą, 400x300 cm",
        price: "999,-",
        img: "https://placekitten.com/g/3500/2500"
    },
    {
        id: 10,
        name: "BJÖRKSTA",
        desc: "Obraz z ramą, 300x300 cm",
        price: "999,-",
        img: "https://placekitten.com/g/2000/1500"
    }
]